// State card game data with rankings
export const STATE_CARDS = [
  {
    "id": 1,
    "name": "California",
    "rank": 1,
    "image": "/images/state/state_1.jpg"
  },
  {
    "id": 2,
    "name": "Texas",
    "rank": 2,
    "image": "/images/state/state_2.jpg"
  },
  {
    "id": 3,
    "name": "Florida",
    "rank": 3,
    "image": "/images/state/state_3.jpg"
  },
  {
    "id": 4,
    "name": "New York",
    "rank": 4,
    "image": "/images/state/state_4.jpg"
  },
  {
    "id": 5,
    "name": "Pennsylvania",
    "rank": 5,
    "image": "/images/state/state_5.jpg"
  },
  {
    "id": 6,
    "name": "Illinois",
    "rank": 6,
    "image": "/images/state/state_6.jpg"
  },
  {
    "id": 7,
    "name": "Ohio",
    "rank": 7,
    "image": "/images/state/state_7.jpg"
  },
  {
    "id": 8,
    "name": "Georgia",
    "rank": 8,
    "image": "/images/state/state_8.jpg"
  },
  {
    "id": 9,
    "name": "North Carolina",
    "rank": 9,
    "image": "/images/state/state_9.jpg"
  },
  {
    "id": 10,
    "name": "Michigan",
    "rank": 10,
    "image": "/images/state/state_10.jpg"
  },
  {
    "id": 11,
    "name": "New Jersey",
    "rank": 11,
    "image": "/images/state/state_11.jpg"
  },
  {
    "id": 12,
    "name": "Virginia",
    "rank": 12,
    "image": "/images/state/state_12.jpg"
  },
  {
    "id": 13,
    "name": "Washington",
    "rank": 13,
    "image": "/images/state/state_13.jpg"
  },
  {
    "id": 14,
    "name": "Arizona",
    "rank": 14,
    "image": "/images/state/state_14.jpg"
  },
  {
    "id": 15,
    "name": "Tennessee",
    "rank": 15,
    "image": "/images/state/state_15.jpg"
  },
  {
    "id": 16,
    "name": "Massachusetts",
    "rank": 16,
    "image": "/images/state/state_16.jpg"
  },
  {
    "id": 17,
    "name": "Indiana",
    "rank": 17,
    "image": "/images/state/state_17.jpg"
  },
  {
    "id": 18,
    "name": "Maryland",
    "rank": 18,
    "image": "/images/state/state_18.jpg"
  },
  {
    "id": 19,
    "name": "Missouri",
    "rank": 19,
    "image": "/images/state/state_19.jpg"
  , "image": "/images/state/state_20.jpg"},
  {
    "id": 20,
    "name": "Wisconsin",
    "rank": 20,
    "image": "/images/state/state_21.jpg"
  },
  {
    "id": 21,
    "name": "Colorado",
    "rank": 21,
    "image": "/images/state/state_22.jpg"
  },
  {
    "id": 22,
    "name": "Minnesota",
    "rank": 22,
    "image": "/images/state/state_23.jpg"
  },
  {
    "id": 23,
    "name": "South Carolina",
    "rank": 23,
    "image": "/images/state/state_24.jpg"
  },
  {
    "id": 24,
    "name": "Alabama",
    "rank": 24,
    "image": "/images/state/state_25.jpg"
  },
  {
    "id": 25,
    "name": "Louisiana",
    "rank": 25,
    "image": "/images/state/state_26.jpg"
  },
  {
    "id": 26,
    "name": "Kentucky",
    "rank": 26,
    "image": "/images/state/state_27.jpg"
  },
  {
    "id": 27,
    "name": "Oregon",
    "rank": 27,
    "image": "/images/state/state_28.jpg"
  },
  {
    "id": 28,
    "name": "Oklahoma",
    "rank": 28,
    "image": "/images/state/state_29.jpg"
  },
  {
    "id": 29,
    "name": "Connecticut",
    "rank": 29,
    "image": "/images/state/state_30.jpg"
  },
  {
    "id": 30,
    "name": "Utah",
    "rank": 30,
    "image": "/images/state/state_31.jpg"
  }
];
